export default __webpack_public_path__ + "static/media/finishEmpty.7b1f7cb0.svg";